import { modalTypes } from "constants/types";
import { hideModal, showModal } from "slices/app/actions/modals";
import { getErrorMessage, refreshPage } from "utils";

const DOWNLOAD_ERROR_TITLE = "Unable To Download Document";
const DOCUMENT_GONE_STATUSES = [404, 409];

export const DOCUMENT_UNAVAILABLE_MESSAGE =
  "This document is no longer available. It may have been deleted.";
export const DOCUMENT_DOWNLOAD_FAILED_MESSAGE =
  "The document could not be downloaded. Please try again.";

const isAupAcceptanceRequired = (status, body) =>
  status === 403 && body?.errorCode === "AUP_ACCEPTANCE_REQUIRED";

const readErrorBody = async (error) => {
  const data = error?.response?.data;
  if (!(data instanceof Blob)) {
    return data;
  }
  try {
    return JSON.parse(await data.text());
  } catch {
    return undefined;
  }
};

const downloadErrorMessage = (status, body) => {
  if (body?.message) {
    return body.message;
  }
  return DOCUMENT_GONE_STATUSES.includes(status)
    ? DOCUMENT_UNAVAILABLE_MESSAGE
    : DOCUMENT_DOWNLOAD_FAILED_MESSAGE;
};

export const showMissingDocumentModal = () => (dispatch) => {
  dispatch(
    showModal(modalTypes.CONFIRMATION, {
      headerText: "Document Not Available",
      bodyText:
        "The document has been deleted and is no longer available. Please refresh and select a different document.",
      okButton: {
        text: "Refresh",
        onOk: () => {
          refreshPage();
          dispatch(hideModal(modalTypes.CONFIRMATION));
        },
      },
    })
  );
};

export const showErrorModal = (error, title) => (dispatch) => {
  // AUP acceptance is surfaced by the axios interceptor via its own modal;
  // suppress the generic ERROR modal so it doesn't stack on top.
  if (isAupAcceptanceRequired(error?.response?.status, error?.response?.data)) {
    return;
  }
  dispatch(
    showModal(modalTypes.ERROR, {
      errorMessage: getErrorMessage(error),
      title,
      handleOk: hideModal(modalTypes.ERROR),
    })
  );
};

const isAupModalShowing = (getState) =>
  getState?.()?.modals?.some(
    (modal) => modal.modalType === modalTypes.AUP_ACCEPTANCE
  );

export const showDownloadErrorModal = (error) => async (dispatch, getState) => {
  const status = error?.response?.status;
  const body = await readErrorBody(error);
  if (isAupAcceptanceRequired(status, body)) {
    if (error.response.data instanceof Blob && !isAupModalShowing(getState)) {
      dispatch(showModal(modalTypes.AUP_ACCEPTANCE));
    }
    return;
  }
  dispatch(
    showModal(modalTypes.ERROR, {
      errorMessage: downloadErrorMessage(status, body),
      title: DOWNLOAD_ERROR_TITLE,
      handleOk: hideModal(modalTypes.ERROR),
    })
  );
};

export const validateErrorResponse = (error) => (dispatch) => {
  const lockedItems = error?.response?.data?.lockedItems;

  if (error?.response?.status === 423 && lockedItems) {
    dispatch(
      showModal(modalTypes.LOCKED_ITEMS_MODAL, {
        lockedItems,
        handleOk: hideModal(modalTypes.LOCKED_ITEMS_MODAL),
      })
    );
  } else {
    dispatch(showErrorModal(error));
  }
};
